import { z } from 'zod';

import { CustomerVehicleResponseSchema } from './customer-vehicle.schemas.js';

export const ListPartyVehiclesResponseSchema = z.object({
  items: z.array(CustomerVehicleResponseSchema),
});

export type ListPartyVehiclesResponse = z.infer<typeof ListPartyVehiclesResponseSchema>;
